

global.LivestreamBlock = (function ($) {

	function init() {
		checkTimeAndSetCorrectText();
	}

	function checkTimeAndSetCorrectText() {
		var badgeStart = $('.js-live-badge-text-start');
		var badgeIsLive = $('.js-live-badge-text-is-live');
		var descriptionStart = $('.js-live-description-text-start');

		var startingTime = $('.js-live-badge-time').data('datetime');
		var startingTimeHours = startingTime.substring(0, 2);
		var startingTimeMins = startingTime.substring(3, 5);

		var startingDateTime = new Date();
		startingDateTime.setHours(startingTimeHours, startingTimeMins, 0);
		var startingDateTimeTimestamp = startingDateTime.getTime();

		badgeStart.fadeToggle('slow', 'linear');

		var intervalId = setInterval(function () {
			var localTime = new Date();

			// Converts the local time to a locale specific format,
			// including adjusting for timezone and splitting into array first will make it work in all browsers
			var localTimeArr = localTime.toLocaleString('sv-SE', { timeZone: 'Europe/Stockholm' }).split(/[- :]/);	
			var currentDateTimeCentralTimeZone = new Date(localTimeArr[0], localTimeArr[1] - 1, localTimeArr[2], localTimeArr[3], localTimeArr[4], localTimeArr[5]);
		
			var currentDateTimeCentralTimeZoneTimestamp = currentDateTimeCentralTimeZone.getTime();

			if (currentDateTimeCentralTimeZoneTimestamp >= startingDateTimeTimestamp) {
				clearInterval(intervalId);
				badgeStart.hide();
				descriptionStart.hide();
				badgeIsLive.fadeToggle(250, 'linear');
			}

		}, 2000);
	}

	return {
		init: init
	};
})(jQuery);
